export class Job {
  public jobNumber: string;
  public batteryQuantity: string;
  public batteryBrand: string;
  public batteryModel: string;
  public customerName: string;
  public jobCreationDate: Date;
  public jobCompletionDate: Date;
  public contractStartDate: Date;
  public contractEndDate: Date;
  public quotation: string;
  public contractSum: string;
  public remarks: string;
  public jobIds: number;
  public isActive: number;
  public customerStatus: number;
  public fireServiceExpiryDate: Date;
  public spareParts: string;
  public vendorOrSubcontractor: string;
  public ecall: string;
  public customer: any;
  public customerId: string;
  public pmFrequency: number;
  public customerShortName: string;

  constructor (
    jobNumber = '',
    batteryQuantity = '',
    batteryBrand = '',
    batteryModel = '',
    customerName = '',
    jobCreationDate = '',
    jobCompletionDate = '',
    contractStartDate = '',
    contractEndDate = '',
    quotation = '',
    contractSum = '',
    remarks = '',
    jobIds = -1,
    isActive = -1,
    customerStatus = -1,
    fireServiceExpiryDate = '',
    spareParts = '',
    vendorOrSubcontractor = '',
    ecall = '',
    pmFrequency = '',
    customer = {},
    customerId = '',
    customerShortName = ''
  ) { }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/job.ts